// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1e_5J","requiredAsterisk":"Info_requiredAsterisk__3XGgH"};